import axios from 'axios';
import { toUpper } from 'lodash';

/*
Change baseURL to suit your project needs.
*/
const http = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL,
  timeout: 5000,
});

const httpPayin = (config) => {
  const platform = config.platformName ? config.platformName.toUpperCase() : 'SEVEN';
  const DC = toUpper(config.platformDataCenter);
  const path = DC ? `VUE_APP_${platform}_API_${DC}` : `VUE_APP_${platform}_API`;
  const baseURL = config.customDomain ? `https://${config.customDomain}/svn` : process.env[path];
  return axios.create({
    baseURL,
    timeout: 5000,
  });
};

const httpV2Backend = (productName) => {
  const baseURL = process.env[`VUE_APP_${productName.replace('V2', '').toUpperCase()}_BASEURL`] || process.env.VUE_APP_GAMES_BASEURL;
  return axios.create({
    baseURL,
    timeout: 5000,
  });
};

const httpCancelTicket = (config) => {
  const platform = config.platformName ? config.platformName.toUpperCase() : 'SEVEN';
  const DC = toUpper(config.platformDataCenter);
  const path = DC ? `VUE_APP_${platform}_API_${DC}` : `VUE_APP_${platform}_API`;
  const baseURL = config.customDomain ? `https://${config.customDomain}/svn` : process.env[path];

  return axios.create({
    baseURL,
    timeout: 5000,
  });
};

const httpLastTickets = (config) => {
  const platform = config.platformName && config.platformName === 'playtech'
    ? config.platformName.toUpperCase()
    : 'NGS';
  const DC = toUpper(config.platformDataCenter);
  const path = DC ? `VUE_APP_${platform}_API_${DC}` : `VUE_APP_${platform}_API`;
  const baseURL = config.customDomain ? `https://${config.customDomain}/gms` : process.env[path];

  return axios.create({
    baseURL,
    timeout: 8000,
  });
};

const httpReadApi = () => axios.create({
  baseURL: process.env.VUE_APP_READ_API,
  timeout: 5000,
});

const httpStreamMapping = axios.create({
  baseURL: process.env.VUE_APP_STREAM_MAPPING_API,
  timeout: 5000,
});

const httpTicketCheck = (config) => {
  const { ngsTicketCheck } = config.ui.config;
  const platform = config.platformName ? config.platformName.toUpperCase() : 'SEVEN';
  const DC = toUpper(config.platformDataCenter);
  let path;

  if (ngsTicketCheck) {
    path = DC ? `VUE_APP_NGS_API_${DC}` : 'VUE_APP_NGS_API';
  } else {
    path = DC ? `VUE_APP_${platform}_API_${DC}` : `VUE_APP_${platform}_API`;
  }
  const baseURL = config.customDomain ? `https://${config.customDomain}/svn` : process.env[path];

  return axios.create({
    baseURL,
    timeout: 5000,
  });
};

const httpStatistics = (config) => {
  const platform = config.platformName && config.platformName === 'playtech'
    ? config.platformName.toUpperCase()
    : 'NGS';
  const DC = toUpper(config.platformDataCenter);
  const path = DC ? `VUE_APP_${platform}_API_${DC}` : `VUE_APP_${platform}_API`;
  const baseURL = config.customDomain ? `https://${config.customDomain}/gms` : process.env[path];

  return axios.create({
    baseURL,
    timeout: 5000,
  });
};

const httpResults = (config) => {
  const platform = config.platformName && config.platformName === 'playtech'
    ? config.platformName.toUpperCase()
    : 'NGS';
  const DC = toUpper(config.platformDataCenter);
  const path = DC ? `VUE_APP_${platform}_API_${DC}` : `VUE_APP_${platform}_API`;
  const baseURL = config.customDomain ? `https://${config.customDomain}/gms` : process.env[path];
  return axios.create({
    baseURL,
    timeout: 5000,
  });
};

export {
  http,
  httpPayin,
  httpCancelTicket,
  httpLastTickets,
  httpTicketCheck,
  httpStreamMapping,
  httpStatistics,
  httpResults,
  httpV2Backend,
  httpReadApi,
};
